var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header'),_c('intro',{attrs:{"option":_vm.option}}),_c('features'),_c('offer'),_c('payments'),_c('services'),_c('partners'),_c('contact'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }